export default __webpack_public_path__ + "static/media/Category-19.95c0de83.jpg";